import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-dropdown";
import axios from "axios";

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
      categories: [],
      defaultCategory: "",
      searchObj: {},
      category: "",
      categoryLabel: ""
    };

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.updateInput = this.updateInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCategories = this.loadCategories.bind(this);
  }

  componentDidMount() {
    this.loadCategories();
  }

  componentDidUpdate(prevprop) {
    if (prevprop.searchText != this.props.searchText) {
      if (this.props.searchText) {
        this.setState({
          searchObj: {
            keyword: this.props.searchText
          },
          searchText: this.props.searchText
        });
      }
    }
  }

  loadCategories() {
    axios.get(this.props.api).then(results => {
      let categories = results.data.map(cat => ({
        label: cat.Title,
        value: cat.ID
      }));
      categories.unshift({ label: "All Categories", value: "" });
      this.setState({ categories });
    });
  }

  updateInput(event) {
    this.setState({ searchText: event.target.value });
  }

  handleSubmit() {
    this.setState(
      {
        searchObj: {
          keyword: this.state.searchText,
          category: this.state.category
        }
      },
      () => {
        this.props.updateSearch(this.state.searchObj, this.state.categoryLabel);
      }
    );
  }

  onSelect(option) {
    if (option.value) {
      this.setState({
        category: option.value,
        categoryLabel: option.label
      });
    } else {
      this.setState({
        category: "",
        categoryLabel: ""
      });
    }
  }

  onKeyUp(ev) {
    const key = ev.which || ev.keyCode;
    if (key === 13) {
      this.handleSubmit();
    }
  }

  render() {
    return (
      <div className="articleSearchForms__inner">
        <div className="col-key">
          <label>Keyword</label>
          <input
            id="keyword"
            type="text"
            onChange={this.updateInput}
            onKeyUp={this.onKeyUp}
            name="search"
            defaultValue={this.props.searchText}
            placeholder="Search for a topic"
          />
        </div>
        <div className="col-cat">
          <label>Filter by Category</label>
          <Dropdown
            options={this.state.categories}
            onChange={this.onSelect}
            value={this.state.categoryLabel}
            placeholder="All Categories"
          />
        </div>
        <div className="col-sub">
          <button
            type="Submit"
            id="submit"
            className="searchButton"
            onClick={this.handleSubmit}
          >
            Search
          </button>
        </div>
      </div>
    );
  }
}

SearchBar.propTypes = {
  api: PropTypes.string,
  updateSearch: PropTypes.func,
  searchText: PropTypes.string
};

export default SearchBar;
